module.exports = __webpack_public_path__ + "img/avatar.ef92f540.jpg";